var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 249,
    height: 100,
    viewBox: "0 0 249 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M133.432 69.0982C134.261 68.9196 136.258 68.8537 136.463 67.0772C136.562 66.2245 136.119 64.6721 136.701 64.6664C137.599 64.6576 138.825 67.3164 139.409 68.564C142.721 75.5921 149.392 74.0209 152.759 71.6368C164.444 63.3496 168.616 38.4676 183.515 26.4643C198.039 14.757 228.303 -3.11429 248.288 0.507588C238.558 5.63519 232.991 7.74758 233.329 21.0075C215.782 18.0928 209.758 36.4548 211.79 50.4096C194.907 53.7609 179.964 56.6923 182.178 76.2192C169.097 69.5418 144.26 90.0898 139.947 99.6328C138.98 95.1026 133.432 69.0982 133.432 69.0982Z",
    fill: "url(#paint0_linear_501_2412)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.429 69.0971C132.6 69.2757 130.75 70.0299 129.835 68.4922C129.396 67.7547 129.166 66.1563 128.633 66.3894C127.809 66.7492 127.777 69.6809 127.752 71.0512C127.605 78.8196 120.87 80.1153 116.825 79.3144C102.774 76.5293 88.7875 55.535 70.2896 50.6677C52.245 45.9242 17.3208 41.9925 0.565245 53.4696C11.5404 54.1699 17.4849 53.8209 22.5992 66.0608C37.4211 56.2263 50.4213 70.5183 54.2779 84.09C71.0539 80.24 85.8916 76.8047 91.8543 95.5296C101.061 84.088 132.129 92.6836 139.966 99.6289C138.997 95.0993 133.429 69.0971 133.429 69.0971Z",
    fill: "url(#paint1_linear_501_2412)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_501_2412",
    x1: 231.04,
    y1: 60.6576,
    x2: 143.085,
    y2: 35.4368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20283B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#1E2537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#191F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#121419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F1012"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_501_2412",
    x1: 142.663,
    y1: 90.2248,
    x2: 1.62261,
    y2: 49.7822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20283B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#1E2537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#191F2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#121419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F1012"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBat);
export default __webpack_public_path__ + "static/media/bat.6740fad370a93d18981a773d708c8e64.svg";
export { ForwardRef as ReactComponent };